import React from "react";
import { Box, Grid, useTheme } from "@mui/material";
import Product from "./Product/Product";
import styles from "./styles";
import { useCartContext } from "@/hooks/useCartContext";
var Products = function () {
    var products = useCartContext().products;
    var theme = useTheme();
    var classes = styles(theme);
    return (React.createElement(Box, { component: "main", sx: classes.content },
        React.createElement(Box, { sx: classes.toolbar }),
        React.createElement(Grid, { container: true, justifyContent: "center", spacing: 4 }, products.map(function (product) { return (React.createElement(Grid, { item: true, key: product.id, xs: 12, sm: 6, md: 4, lg: 3 },
            React.createElement(Product, { product: product }))); }))));
};
export default Products;
